import { camelizeKeys } from 'humps';

export const patch = (state, data) =>
  state.merge({
    ...camelizeKeys(data),
    _patched: Date.now(),
  });
